import { sum } from '@/utils/calculation';
import Decimal from '@/utils/decimal';
import { IInvoice, invoiceTaxSubtotals as _invoiceTaxSubtotals, IInvoiceTaxSubtotal } from './invoice-calculations-interface';
import { invoiceTaxExclusiveAmount as _invoiceTaxExclusiveAmount } from './invoice-calculations-interface';

export interface IOverdueNotice {
  additionalCharge: Decimal;
}

// Invoice calculations

export const invoiceTaxSubtotals = (invoice: IInvoice): IInvoiceTaxSubtotal[] => {
  const subtotals = _invoiceTaxSubtotals(invoice);
  const zeroTax = subtotals.find(subtotal => subtotal.taxPercent.isZero());
  const noticeSum = sum(invoice.invoiceOverdueNotices.map(notice => notice.additionalCharge)).toDecimalPlaces(2);

  if (zeroTax) {
    zeroTax.taxableAmount = sum([ zeroTax.taxableAmount, noticeSum ]).toDecimalPlaces(2);
    zeroTax.taxInclusiveAmount = sum([ zeroTax.taxInclusiveAmount, noticeSum ]).toDecimalPlaces(2);
  } else {
    subtotals.push({
      taxAmount: new Decimal(0),
      taxPercent: new Decimal(0),
      taxInclusiveAmount: noticeSum,
      taxableAmount: noticeSum,
    });
  }
  return subtotals;
};

export const invoiceTaxExclusiveAmount = (invoice: IInvoice) => {
  return sum([ _invoiceTaxExclusiveAmount(invoice), sum(invoice.invoiceOverdueNotices.map(notice => notice.additionalCharge)) ]).toDecimalPlaces(2);
};
